<template>
  <section class="box has-border-light">
    <div class="p-5">
      <SkeletonView :height="90" />
      <div class="columns m-b-15 m-t-15">
        <div class="column is-6">
          <SkeletonView :height="25" />
          <div class="ml-4 my-4" v-for="i in 7" :key="i">
            <SkeletonView :height="20" />
          </div>
        </div>
        <div class="column is-6">
          <SkeletonView :height="25" />
          <div class="ml-4 my-4" v-for="i in 4" :key="i">
            <SkeletonView :height="20" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SelfServeBillingCardSkeleton',
  components: { SkeletonView }
};
</script>
